// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Stock_AdjustResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response Contract for POST /so/stock/adjust
 *
 * Returns the inserted stock-movement id (`{movement_id: int}`).
 *
 * @see So_stock_movements_model::createMovement()
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Stock_AdjustResponseDados {
movement_id: number
}

export type Stock_AdjustResponse = ApiResponse<Stock_AdjustResponseDados>;

registerResponseContract('Stock_AdjustResponse', {
  movement_id: { type: 'number',  required: true },
})
